import { getDescendentEdges } from 'automation-ui-directed-graph/DirectedNodes';
import { translateToGraph } from 'automation-ui-canvas/utils/platformWorkflowTranslators';
export function correctCyclesInFlowAfterMove(flow, movedActionId) {
  const flowAsGraph = translateToGraph(flow, true);
  const validGoToIdsFromMovedAction = flowAsGraph.getNodeIdsForGoToNode(movedActionId);
  const descendentActionIds = getDescendentEdges(movedActionId, flowAsGraph.getEdges()).map(edge => edge.getFromNode()).filter(nodeId => nodeId !== movedActionId);
  return flow.removeGoTosCausingCycles(movedActionId, [...validGoToIdsFromMovedAction, ...descendentActionIds]);
}